module.exports = __webpack_public_path__ + "img/shochi.7b24107b.png";